import { useState } from 'react'
import { Box, Button, Collapse, IconButton, Link } from '@mui/material'
import { Download, Close, Forward } from '@mui/icons-material'

export interface PresentationControlPanelProps {
  swiper: any
  pdfURL: string
  pptURL: string
  pptxURL: string
  activeIndex: number
  onSelectNext: any
  onSelectPrev: any
}
export const PresentationControlPanel: React.FC<
  PresentationControlPanelProps
> = ({ 
        activeIndex,
        swiper,
        pdfURL,
        pptURL,
        pptxURL,
        onSelectNext,
        onSelectPrev 
}) => {
  const [open, setOpen] = useState(false)
  const [downloadVisible, setDownloadVisible] = useState(false)

  return (
    <>
      <Box
        slot="container-start"
        width="100%"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#59595b',
          paddingTop: '3px',
          paddingBottom: '3px',
        }}
      >
        <Box sx={{ width: ['50%', '80%', '90%'], height: '25px' }}></Box>
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <Button
            sx={{
              color: '#cccccc',
            }}
            onClick={onSelectPrev}
          >
            <Forward sx={{ fontSize: '30px', transform: 'rotate(180deg)' }} />
          </Button>
          <Button sx={{ color: '#cccccc' }} onClick={onSelectNext}>
            <Forward sx={{ fontSize: '30px' }} />
          </Button>
          <Box
            sx={{
              borderRadius: '4px',
              paddingX: '4px',
              marginLeft: '10px',
              fontSize: '15px',
              letterSpacing: '-1px',
              color: '#cccccc',
              fontWeight: 'bolder',
              textTransform: 'uppercase',
            }}
          >
            {activeIndex + 1} / {swiper?.slides?.length}
          </Box>
        </Box>
        <Box sx={{ width: '25%', display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            sx={{
              color: '#cccccc',
            }}
            onClick={() => {
              setOpen((stale) => !stale)
            }}
          >
            <Download sx={{ fontSize: '30px' }} />
          </Button>
        </Box>
      </Box>

      <Collapse
        in={open}
        sx={{
          width: '100%',
          position: 'absolute',
          zIndex: 1000,
        }}
        onEntered={() => {
          setDownloadVisible(true)
        }}
        onExiting={() => {
          setDownloadVisible(false)
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              border: '1px solid grey',
            }}
          >
            <Box
              sx={{
                backgroundColor: 'black',
                color: 'white',
                paddingX: '10px',
                paddingTop: '4px',
                fontSize: '11px',
                fontWeight: 'bold',
                opacity: 0.85,
              }}
            >
              Available formats:
            </Box>
            <Box
              sx={{
                backgroundColor: 'black',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                opacity: 0.85,
              }}
            >
              {pdfURL && (
                <Link
                  sx={{
                    fontSize: '12px',
                    fontWeight: 'bolder',
                    padding: '4px',
                    color: 'white',
                    textDecoration: 'underline',
                  }}
                  href={pdfURL}
                  download
                  onClick={() => setOpen(false)}
                >
                  PDF
                </Link>
              )}
              {pptURL && (
                <Link
                  sx={{
                    fontSize: '12px',
                    fontWeight: 'bolder',
                    padding: '4px',
                    color: 'white',
                    textDecoration: 'underline',
                  }}
                  href={pptURL}
                  download
                  onClick={() => setOpen(false)}
                >
                  PPT
                </Link>
              )}
              {pptxURL && (
                <Link
                  sx={{
                    fontSize: '12px',
                    fontWeight: 'bolder',
                    padding: '4px',
                    color: 'white',
                    textDecoration: 'underline',
                  }}
                  href={pptxURL}
                  download
                  onClick={() => setOpen(false)}
                >
                  PPTX
                </Link>
              )}
            </Box>
          </Box>
          <IconButton
            size="small"
            onClick={() => {
              setOpen(false)
            }}
            sx={{
              backgroundColor: 'black',
              color: 'white',
              opacity: 0.8,
              position: 'relative',
              top: '-25px',
              left: '-10px',
              zIndex: 1000,
              borderRadius: '12px',
              border: '2px solid grey',
              visibility: !downloadVisible ? 'hidden' : 'visible',
              '&:hover': {
                opacity: 0.8,
                backgroundColor: 'black',
              },
            }}
          >
            <Close fontSize="inherit" />
          </IconButton>
        </Box>
      </Collapse>
    </>
  )
}

export default PresentationControlPanel
